import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import ItemList from 'flarum/common/utils/ItemList';
import FieldSet from 'flarum/common/components/FieldSet';
import Button from 'flarum/common/components/Button';
import RequestErasureModal from '../components/RequestErasureModal';
import RequestDataExportModal from '../../common/components/RequestDataExportModal';
export default function extendUserSettingsPage() {
  extend('flarum/forum/components/SettingsPage', 'settingsItems', function (items) {
    const user = this.user;
    if (!user) {
      return;
    }
    items.add('dataItems', m(FieldSet, {
      className: "Settings-gdpr FieldSet--form",
      label: app.translator.trans('flarum-gdpr.forum.settings.data.heading')
    }, this.dataItems().toArray()), -100);
  });
  override('flarum/forum/components/SettingsPage', 'dataItems', function () {
    const items = new ItemList();
    items.add('gdprErasure', m("div", {
      className: "Form-group gdprErasure-container"
    }, m("p", {
      className: "helpText"
    }, app.translator.trans('flarum-gdpr.forum.settings.request_erasure_help')), m(Button, {
      className: "Button Button-gdprErasure",
      icon: "fas fa-user-minus",
      onclick: () => app.modal.show(RequestErasureModal)
    }, app.translator.trans('flarum-gdpr.forum.settings.request_erasure_button'))), 50);
    items.add('gdprExport', m("div", {
      className: "Form-group gdprExport-container"
    }, m("p", {
      className: "helpText"
    }, app.translator.trans('flarum-gdpr.forum.settings.export_data_help')), m(Button, {
      className: "Button Button-gdprExport",
      icon: "fas fa-file-export",
      onclick: () => app.modal.show(RequestDataExportModal, {
        user: this.user
      })
    }, app.translator.trans('flarum-gdpr.forum.settings.export_data_button'))), 40);
    return items;
  });
}
flarum.reg.add('flarum-gdpr', 'forum/extenders/extendUserSettingsPage', extendUserSettingsPage);